import AdminsPageLayout from 'container/AdminsPageLayout'

const Admins = () => <AdminsPageLayout />

export default Admins
